import React, { useState, useEffect } from 'react'

const Gallary = () => {
    const [data, setData] = useState([])
    const [upload, setUpload] = useState(false)
    const [message, setMessage] = useState('')
    const [state, setState] = useState({
        title:'', imageFile:null
    })  

    const fetchData = async () => {
        try {
            const ACTION_URL = `https://www.durgacollege.in/dashboard/backend/fetch_gallary.php`;
            const res = await fetch(ACTION_URL, {method:'GET'})
            const data = await res.json()
            if (res.status === 200 && data) {
                setData(data)
            }
        } catch (error){
            console.log(error);
        }
    }

    useEffect(() => {
        fetchData()
        document.title = 'Gallary | Durga College Admin panel'
    }, [])

    const submitEvent = async e => {
        e.preventDefault()  
        const {title, imageFile} = state      
        if (title && imageFile) {
            try {
                setUpload(true)
                const formData = new FormData(e.target)
                formData.append('action', 'addImage')
                const ACTION_URL = `https://www.durgacollege.in/dashboard/backend/action.php`;
                const params = {
                    method: 'POST',
                    body: formData
                }
                const res = await fetch(ACTION_URL, params)
                const data = await res.json()
                if (res.status === 200 && data.status) {
                    setMessage(<div className="mb-3 success-message">{data.message}</div>)
                    setState({title:'', imageFile:null})
                    fetchData()   
                } else {
                    setMessage(<div className="mb-3 error-message">{data.message}</div>)
                }
                setUpload(false)
            } catch (error) {
                setMessage(<div className="mb-3 error-message">{error.message}</div>)
                setUpload(false)
            }
        }
    }


    return (
        <div className="gallary">
            <h3 className="mb-3"><i className="bi bi-image-fill"></i> Gallary</h3>
            <div id="message">{message}</div>
            <form method="post" className="mb-3" onSubmit={submitEvent}>
                <div className="mb-3">
                    <label htmlFor="title" className="form-label">Title : *</label>
                    <input
                        type="type"
                        name="title"
                        className="form-control"
                        onChange={e => setState({...state, title:e.target.value})} 
                    />                   
                </div>
                <div className="mb-3">
                    <label htmlFor="imageFile" className="form-label">Choose Multiple Files : *</label>
                    <input
                        type="file"
                        name="imageFile[]"
                        className="form-control"
                        accept="image/*"
                        multiple
                        onChange={e => setState({...state, imageFile:e.target.files[0]})} 
                    />
                </div> 
                <button type="submit" className="btn btn-primary">
                {
                    !upload ? 'Upload' : 'Uploading...'
                }
                </button>
            </form>
            <hr/>
            <div className="d-flex flex-nowrap">
            {
                data.map((elem, idx) => {
                    return (
                        <div className="image-box" key={idx}>
                            <img src={`https://www.durgacollege.in/images/gallary/${elem.filename}`} alt={idx} />
                        </div>
                    )
                })
            }
            </div>
        </div>
    )
}

export default Gallary
